import { createReducer } from '@reduxjs/toolkit'
import { createSelector } from 'reselect'

import { searchJobs } from './jobSearch.actions'
import { logout } from '../user/user.action'

const initialState = {
  jobs: [],
  jobsPage: 0,
  jobsPageSize: 0,
  jobsTotal: 0,

  loading: {
    searchJobs: false,
  },
  error: {
    searchJobs: false,
  },
}

const jobSearchReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(searchJobs.fulfilled, (state, action) => {
      state.jobs = action.payload.results
      state.jobsPage = action.payload.page
      state.jobsTotal = action.payload.total
      state.jobsPageSize = action.payload.page_size

      state.loading.searchJobs = false
      state.error.searchJobs = false
    })
    .addCase(searchJobs.pending, (state) => {
      state.loading.searchJobs = true
      state.error.searchJobs = false
    })
    .addCase(searchJobs.rejected, (state) => {
      state.loading.searchJobs = false
      state.error.searchJobs = true
    })

    .addCase(logout.fulfilled, () => initialState)

    .addDefaultCase((state) => state)
})

export const jobSearchState = (state) => state.jobSearch

export const selectSearchJobsPagination = createSelector(
  jobSearchState,
  ({ jobs, jobsPage, jobsTotal, jobsPageSize }) => ({ jobs, jobsPage, jobsTotal, jobsPageSize })
)

export const selectSearchJobsLoading = createSelector(
  jobSearchState,
  ({ loading: { searchJobs } }) => searchJobs
)

export const selectSearchJobsError = createSelector(
  jobSearchState,
  ({ error: { searchJobs } }) => searchJobs
)

export default jobSearchReducer
